'use es6';

import Immutable from 'immutable';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import StorefrontFilters from './StorefrontFilters';
const EMPTY_LIST = Immutable.List();
const thinListingDefaults = {
  category: '',
  companyName: '',
  firstPublishedAt: 0,
  credentials: EMPTY_LIST,
  iconUrl: '',
  id: 0,
  installed: false,
  installsCount: 0,
  name: '',
  offeringId: 0,
  recommendation: null,
  recommended: false,
  reviewSummary: null,
  sourceId: '',
  slug: '',
  tagline: ''
};
class ThinListing extends Immutable.Record(thinListingDefaults) {
  constructor(values) {
    var _values;
    if ((_values = values) !== null && _values !== void 0 && _values.credentials) {
      values = Object.assign({}, values, {
        credentials: Immutable.List(values.credentials)
      });
    }
    super(cleanObject(values || {}));
  }
}
const defaults = {
  filters: new StorefrontFilters(),
  items: Immutable.OrderedSet(),
  total: 0
};
class SearchResult extends Immutable.Record(defaults) {
  constructor(json = {}) {
    if (json.filters) {
      json.filters = new StorefrontFilters(json.filters);
    }
    if (json.items) {
      json.items = Immutable.OrderedSet(json.items.map(result => new ThinListing(result)));
    }
    super(json);
  }
}
export default SearchResult;